const paths = {
  main: '/signin',
};

export default paths;
